 import React from 'react';
 import { MotionImage, FadeInSection } from '../ui/MotionPrimitives';

const AboutHero: React.FC = () => {
  return (
    <FadeInSection className="relative w-full bg-black text-white">
      <div className="mx-auto flex max-w-6xl flex-col-reverse items-center gap-8 px-6 pt-44 pb-16 md:flex-row md:gap-12 md:px-10 md:pt-52 md:pb-20">
        {/* Left: Text content */}
        <div className="w-full md:w-1/2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#D88546]">
            About Hogar Dorado House
          </p>
          <h1 className="mt-3 text-3xl font-semibold leading-tight md:text-4xl lg:text-[42px]">
            Strategic Real Estate.
            <br />
            Global Impact.
          </h1>
          <p className="mt-4 max-w-md text-sm text-white/70 md:text-[15px]">
            We connect discerning investors with high-performing real estate assets across the UAE and US, guided by
            deep market intelligence and a commitment to long-term value.
          </p>
        </div>

        {/* Right: Hero image */}
        <div className="w-full md:w-1/2">
          <div className="h-[260px] w-full overflow-hidden rounded-[32px] bg-gray-900 shadow-[0_22px_45px_rgba(15,23,42,0.5)] md:h-[360px]">
            <MotionImage
              src="/images/pics/aboutushero.jpg"
              alt="About Hogar Dorado House"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </div>
    </FadeInSection>
  );
};

export default AboutHero;
